export const adminDe = {
  login: {
    title: 'Admin-Panel',
    subtitle: 'Melden Sie sich an, um Anfragen und Inhalte zu verwalten.',
    email: 'E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Anmeldung läuft…',
    failed: 'E-Mail oder Passwort ist nicht korrekt.',
    backToSite: 'Zurück zur Website',
  },
  nav: {
    dashboard: 'Übersicht',
    leads: 'Anfragen',
    projects: 'Projekte',
    content: 'Inhalte',
    settings: 'Einstellungen',
    users: 'Benutzer',
    logout: 'Abmelden',
    viewSite: 'Website ansehen',
  },
  dashboard: {
    title: 'Übersicht',
    subtitle: 'Alle Anfragen auf einen Blick.',
    total: 'Anfragen gesamt',
    last7: 'Letzte 7 Tage',
    last30: 'Letzte 30 Tage',
    open: 'Offen',
    trend: 'Anfragen der letzten 30 Tage',
    byStatus: 'Nach Status',
    recent: 'Neueste Anfragen',
    empty: 'Noch keine Anfragen eingegangen.',
  },
  leads: {
    title: 'Anfragen',
    subtitle: '{{count}} Anfragen',
    search: 'Suchen nach Name, E-Mail, Ort…',
    filterStatus: 'Status',
    filterInterest: 'Interesse',
    all: 'Alle',
    export: 'CSV exportieren',
    empty: 'Keine Anfragen gefunden.',
    emptyHint: 'Passen Sie die Filter an oder warten Sie auf neue Anfragen.',
    columns: {
      name: 'Name',
      contact: 'Kontakt',
      location: 'Ort',
      availability: 'Erreichbarkeit',
      status: 'Status',
      created: 'Eingegangen',
      actions: '',
    },
    detail: {
      title: 'Anfrage',
      contact: 'Kontaktdaten',
      request: 'Anfrage',
      notes: 'Interne Notizen',
      addNote: 'Notiz hinzufügen',
      notePlaceholder: 'Notiz zu dieser Anfrage…',
      noNotes: 'Noch keine Notizen.',
      delete: 'Anfrage löschen',
      deleteConfirmTitle: 'Anfrage wirklich löschen?',
      deleteConfirmBody: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle Notizen werden ebenfalls gelöscht.',
      cancel: 'Abbrechen',
      confirmDelete: 'Endgültig löschen',
      notified: 'Benachrichtigung versendet',
      notNotified: 'Keine Benachrichtigung versendet',
      callNow: 'Anrufen',
      whatsappNow: 'Per WhatsApp antworten',
      whatsappDraft: 'Hallo {{name}}, vielen Dank für Ihre Anfrage bei PV Yourself.',
      emailNow: 'E-Mail schreiben',
    },
  },
  status: {
    NEW: 'Neu',
    CONTACTED: 'Kontaktiert',
    SCHEDULED: 'Termin vereinbart',
    WON: 'Gewonnen',
    LOST: 'Verloren',
  },
  content: {
    title: 'Inhalte',
    subtitle: 'Leistungen und Ablaufschritte der Website bearbeiten.',
    headings: 'Abschnitts-Texte',
    services: 'Leistungen',
    steps: 'Ablaufschritte',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    published: 'Veröffentlicht',
    hidden: 'Ausgeblendet',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    fields: {
      slug: 'Slug',
      icon: 'Icon',
      titleDe: 'Titel (DE)',
      titleEn: 'Titel (EN)',
      bodyDe: 'Text (DE)',
      bodyEn: 'Text (EN)',
      isPublished: 'Auf der Website anzeigen',
    },
    save: 'Speichern',
    cancel: 'Abbrechen',
    saved: 'Änderungen gespeichert.',
  },
  settings: {
    title: 'Einstellungen',
    subtitle: 'Firmendaten und Texte der Startseite.',
    save: 'Speichern',
    saved: 'Einstellungen gespeichert.',
    password: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    passwordChanged: 'Passwort geändert.',
  },
  users: {
    title: 'Benutzer',
    subtitle: 'Zugänge zum Admin-Panel verwalten.',
    add: 'Benutzer hinzufügen',
    name: 'Name',
    email: 'E-Mail',
    role: 'Rolle',
    active: 'Aktiv',
    lastLogin: 'Letzte Anmeldung',
    never: 'Nie',
    create: 'Anlegen',
    password: 'Passwort',
  },
  projects: {
    title: 'Projekte',
    subtitle: 'Ausgeführte Anlagen als Referenz auf der Website zeigen.',
    add: 'Projekt hinzufügen',
    edit: 'Projekt bearbeiten',
    empty: 'Noch keine Projekte angelegt.',
    emptyHint: 'Legen Sie Ihr erstes Referenzprojekt an, damit es auf der Website erscheint.',
    chooseFile: 'Datei wählen',
    uploading: 'Wird hochgeladen…',
    tooLarge: 'Die Datei ist zu groß (max. {{max}}).',
    fields: {
      slug: 'Slug',
      location: 'Ort / Region',
      titleDe: 'Titel (DE)',
      titleEn: 'Titel (EN)',
      descriptionDe: 'Beschreibung (DE)',
      descriptionEn: 'Beschreibung (EN)',
      sizeKwp: 'Größe in kWp',
      completedAt: 'Fertigstellung',
      componentsDe: 'Komponenten (DE)',
      componentsEn: 'Komponenten (EN)',
      image: 'Foto',
      video: 'Video',
      isPublished: 'Auf der Website anzeigen',
    },
  },
  sections: {
    pillars: 'Preisvorteil',
    services: 'Leistungen',
    process: 'Ablauf',
    projects: 'Projekte',
    trust: 'Vertrauen',
    contact: 'Kontakt',
    fields: { eyebrow: 'Kleine Überschrift', title: 'Überschrift', subtitle: 'Untertitel' },
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    saving: 'Wird gespeichert…',
    error: 'Fehler',
    rowsPerPage: 'Zeilen pro Seite',
  },
};
